import React from 'react';
import {styled, tokens} from '@packages/utilities/styled';
import OneLiner from './OneLiner';
import ButtonShell from './ButtonShell';
import {ChevronSmallDownIcon} from '@packages/systems/spring';
import {emptyObject} from '@packages/utilities/fp/utils';

const Label = styled(OneLiner)({
  justifySelf: 'start',
  width: '100%',
});

const justifySelfEnd = {justifySelf: 'end'} as const;

const StyledButton = styled(ButtonShell)(({
  theme: {gutters, select},
  hasIndicator,
}) => {
  const styles = {
    color: tokens.colors.textPrimary,
    display: 'grid',
    gridTemplateColumns: hasIndicator ? `auto ${gutters.x16}px` : 'auto',
    gridAutoFlow: 'column',
    justifyContent: 'unset',
    width: '100%',
    flexGrow: 'unset',
    paddingLeft: gutters.x4 * 2,
    boxSizing: 'border-box',
  } as const;
  if (select.height) return {...styles, height: select.height};
  return styles;
});

const SelectButton = ({
  children,
  dynamic,
  indicator,
  ...rest
}: {
  children: React.ReactNode;
  dynamic?: boolean;
  indicator?: boolean;
}) => {
  return (
    <StyledButton
      data-legacy-ds="SelectButton"
      {...rest}
      dynamic={dynamic}
      hasIndicator={indicator}
    >
      <Label>{children}</Label>
      {indicator ? <ChevronSmallDownIcon style={justifySelfEnd} /> : null}
    </StyledButton>
  );
};

const selectButtonVariations = {
  // @ts-expect-error - TS7031 - Binding element 'Select' implicitly has an 'any' type.
  error: ({theme: {Select}}) => Select.error,
} as const;

/**
 * @deprecated use `SelectTrigger` from `@packages/systems/spring` instead
 */
export default styled(SelectButton)(emptyObject, selectButtonVariations);
